import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreateSalesImportCommand, UpdateSalesImportCommand, GetSalesImportQueryResponse } from '../../interfaces/interfaces';
import { SalesImportService } from 'src/app/services/sales-import.service';
import { AuthService } from 'src/app/services/auth.service';
import { StreamingService } from 'src/app/services/streaming.service';
import { take } from 'rxjs/operators';
import { map, Observable } from 'rxjs';
import { AdaptiveMode } from '@progress/kendo-angular-dateinputs';
import { DatePipe } from '@angular/common';
import { State, process, CompositeFilterDescriptor, filterBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
import { AddEvent, DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { environment } from 'src/environments/environment';
import { TelerikReportViewerComponent } from '@progress/telerik-angular-report-viewer';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'sdc-maintain-watch',
  templateUrl: './maintain-watch.component.html',
  styleUrls: ['./maintain-watch.component.scss']
})
export class MaintainWatchComponent implements OnInit {
  @ViewChild('viewer1') viewer: TelerikReportViewerComponent;

  isLoading = true;
  isUpdate = false;
  watchForm: UntypedFormGroup;
  processDate = false;

  userName: string;
  role: string;

  currentDate = new Date();
  createWatchCommand: CreateSalesImportCommand;
  updateWatchCommand: UpdateSalesImportCommand;

  public myFiles: Array<File>;

  public allowCustom = true;
  
  public value: Date = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), (new Date()).getHours());
  public format = "MM/dd/yyyy HH:mm";
  public adaptiveMode: AdaptiveMode = "auto";

  public selectedValues: string = "Creams Lakeside";
  public listItemsStore: Array<string> = [
    "Creams Lakeside",
    "MH Lakeside",
    "MH UBER Lakeside",
    "DISHD",
    "Cart",
    "Employees",
    "Products",
  ];

  //public watch: GetWatchQueryResponse;

  constructor(
    @Inject(MAT_DIALOG_DATA) public watch: GetSalesImportQueryResponse,
    public dialogRef: MatDialogRef<MaintainWatchComponent>,
    private watchService: SalesImportService,
    private streamingService: StreamingService,
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private matSnackBar: MatSnackBar,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
  ) {
    
    if (this.watch.id > 0) {
      this.isUpdate = true;
      ////this.value = new Date(this.watch.dateBought);
    }
  }

  ngOnInit(): void {

    this.userName = localStorage.getItem('currentUserName');
    //this.role = localStorage.getitem('currentRole');

    this.listItemsStore = [];
    this.listItemsStore.push("Creams Lakeside");
    this.listItemsStore.push("MH Lakeside");
    this.listItemsStore.push("MH UBER Lakeside");
    this.listItemsStore.push("DISHD");
    this.listItemsStore.push("Cart");
    this.listItemsStore.push("Employees");
    this.listItemsStore.push("Products");

    this.watchForm = this.formBuilder.group({
      store: [null, Validators.required],
      description: [null, Validators.required],
      category: [null, Validators.required],
      name: [null],
      importFileName: [null],
      myFiles: [null],
    },);

    if (this.isUpdate) {
      this.watchService.getSalesImport({ id: this.watch.id }).pipe(take(1)).subscribe({
        next: (response: GetSalesImportQueryResponse) => {
          
          this.watch = response;

          this.watchForm.patchValue(this.watch);

          this.selectedValues = this.watch.store;

        },
        error: (error: HttpErrorResponse) => {
          alert(error);
          this.isLoading = false;
        }
      });
    }
    else {
    }
    this.isLoading = false;
  }

  public onSizeChange(value) {
    this.selectedValues = value;
    this.watchForm.controls.name.patchValue("Transactions");// = "test";
  }

  addWatch(): void {
    this.isLoading = true;
    this.watch.id = 0;

    if (this.watchForm.controls.myFiles.value) {
      const file = this.watchForm.controls.myFiles.value[0];

        this.streamingService.uploadFile(
            file,
            this.selectedValues,  // store name
            'Transactions List',   // category
            this.watchForm.controls.description.value, // description
            this.watchForm.controls.name.value, // name
            this.watch.id, //id
        ).subscribe({
            next: () => {
                this.isLoading = false;
                this.displayMessage('File Uploaded');
                this.dialogRef.close();
            },
            error: (error: HttpErrorResponse) => {
                alert("Streaming Error: " + error);
                this.isLoading = false;
            }
        });
    }
  }

  updateWatch(): void {
    this.isLoading = true;
  }

  updateWatchEvent(command: UpdateSalesImportCommand): void {
  }

  private displayMessage(message: string): void {
    this.matSnackBar.open(message, 'Close', {
      duration: 7000
    });
  }

  printBuyIn(): void {

    window.open('watch/printwatch/:2', '_blank');
  }

  importFile(): void {

  }

  removeImport(): void {
    this.isLoading = true;
    //this.watch.id = 0;

    this.authService.deleteImport(this.watch.id).subscribe({
      next: () => {
        this.isLoading = false;
        this.displayMessage('File Uploaded');
        this.dialogRef.close();
      },
      error: (error: HttpErrorResponse) => {
        alert("Streaming Error: " + error);
        this.isLoading = false;
      }
    });
  }

}
